import { requestLaravel } from "../../../utils/api";
import { ApiResponse } from "../../modules/core/_models";
import { ILoginForm, IRegistrationDropdownData, IRegistrationForm } from "./models";

export function LoginAPI(payload: ILoginForm): Promise<ApiResponse> {
    const data = {
        email: payload.uname,
        password: payload.pwd
    };
    return requestLaravel("/login", data);
}

export function RegistrationAPI(payload: IRegistrationForm): Promise<ApiResponse> {
    return requestLaravel<ApiResponse>("/registration/register-user", payload);
}

export function getRegistrationDropdownDataAPI(signal?: AbortSignal): Promise<ApiResponse<IRegistrationDropdownData>> {
    return requestLaravel<ApiResponse<IRegistrationDropdownData>>(
        "/registration/get-registration-dropdown-data",
        {},
        { signal }
    );
}

export function ForgotPasswordAPI(payload: { email: string }): Promise<ApiResponse> {
    return requestLaravel<ApiResponse>("/registration/forget-password", payload);
}

export function ContactUsAPI(payload: any): Promise<ApiResponse> {
    return requestLaravel<ApiResponse>("/contact/contact-us", payload);

}